document.addEventListener('DOMContentLoaded', function () {
  // document.querySelectorAll('.faq__item').forEach((item) => {
  //   item.addEventListener('toggle', () => {
  //     if (item.open) {
  //       document.querySelectorAll('.faq__item').forEach((other) => {
  //         if (other !== item) other.removeAttribute('open');
  //       });
  //     }
  //   });
  // });
  const form = document.getElementById('founderForm');
  const successBlock = document.querySelector('.join__content.success');
  const formBlock = document.querySelector('.join__content:not(.success)');
  const submitBtn = form.querySelector('button');

  function showError(input, message) {
    let error = input.parentNode.querySelector('.error-msg');

    if (!error) {
      error = document.createElement('p');
      error.className = 'error-msg';
      error.style.color = '#ff5b5b';
      error.style.fontSize = '14px';
      error.style.marginTop = '4px';
      // input.parentNode.appendChild(error);
    }

    error.textContent = message;
    input.classList.add('input-error');
  }

  function clearErrors() {
    form.querySelectorAll('.error-msg').forEach((el) => el.remove());
    form
      .querySelectorAll('.input-error')
      .forEach((el) => el.classList.remove('input-error'));
  }

  function validateForm() {
    clearErrors();

    let valid = true;

    const fullName = document.getElementById('full_name');
    const email = document.getElementById('email');
    const locationField = document.getElementById('location');
    const social = document.getElementById('social');
    const phone = document.getElementById('phone');
    const message = document.getElementById('message');
    const nda = document.getElementById('nda');
    const ugc = document.getElementById('ugc');

    // Nombre
    if (!fullName.value.trim()) {
      showError(fullName, 'Ingresa tu nombre completo');
      valid = false;
    }

    // Email
    if (!email.value.trim()) {
      showError(email, 'Ingresa tu correo electrónico');
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      showError(email, 'Ingresa un email válido');
      valid = false;
    }

    // Ciudad / País
    if (!locationField.value.trim()) {
      showError(locationField, 'Ingresa tu ciudad y país');
      valid = false;
    }

    // Instagram o TikTok
    if (!social.value.trim()) {
      showError(social, 'Ingresa tu cuenta de Instagram o TikTok');
      valid = false;
    }

    // Teléfono
    if (!phone.value.trim()) {
      showError(phone, 'Ingresa tu número de teléfono');
      valid = false;
    }

    // Mensaje
    if (!message.value.trim()) {
      showError(message, 'Escribe un mensaje');
      valid = false;
    }

    // NDA
    if (!nda.checked) {
      showError(nda, 'Debes aceptar los Términos y NDA para continuar');
      valid = false;
    }

    // UGC
    if (!ugc.checked) {
      showError(ugc, 'Debes aceptar la autorización de contenido UGC');
      valid = false;
    }

    return valid;
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    if (!validateForm()) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando...';

    const payload = {
      data: {
        type: 'profile',
        attributes: {
          email: email.value,
          phone_number: document.getElementById('phone').value || null,
          properties: {
            full_name: document.getElementById('full_name').value,
            location: document.getElementById('location').value,
            social: document.getElementById('social').value,
            message: document.getElementById('message').value,
            nda_accepted: document.getElementById('nda').checked,
            ugc_accepted: document.getElementById('ugc').checked,
            form_source: 'Shokko Founder 2025 Landing',
          },
        },
      },
    };

    try {
      const res = await fetch('https://submitfounder-yvpeumq7ya-uc.a.run.app', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const responseData = await res.json();

      if (res.ok) {
        // Caso perfil duplicado

        // 1️⃣ Email inválido

        if (responseData.invalidEmail) {
          alert('El correo ingresado no es válido. Por favor revisalo.');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Unirme como Founder';
          return;
        }

        // 2️⃣ Perfil duplicado
        if (responseData.duplicate === true) {
          alert(
            'Parece que este correo ya está registrado 💜. Gracias por tu interés en ser Founder. Muy pronto sabrás de nosotros.'
          );
          submitBtn.disabled = false;
          submitBtn.textContent = 'Unirme como Founder';

          return;
        }

        // Mostrar bloque de éxito igual
        formBlock.style.display = 'none';
        successBlock.style.display = 'flex';
        successBlock.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.error(responseData);
        alert('Hubo un error al enviar tu postulación.');
      }
    } catch (error) {
      console.error(error);
      alert('Error de conexión.');
    }

    submitBtn.disabled = false;
    submitBtn.textContent = 'Unirme como Founder';
  });

  function trackEvent(action, category, label = '', value = '') {
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
  document.querySelectorAll('a[href="#formulario"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      trackEvent(
        'click_cta_formulario',
        'CTA',
        'Quiero ser Founder - Hero/Nav'
      );
    });
  });
  document.querySelectorAll('.nav__link').forEach((link) => {
    link.addEventListener('click', () => {
      trackEvent('click_nav', 'Navigation', link.textContent.trim());
    });
  });
  document.getElementById('founderForm').addEventListener('submit', () => {
    trackEvent('form_submit', 'Formulario Founder', 'Postulación enviada');
  });
  document.querySelectorAll('a[href$=".pdf"]').forEach((pdf) => {
    pdf.addEventListener('click', () => {
      trackEvent('click_pdf', 'Legal Docs', pdf.getAttribute('href'));
    });
  });
  document.querySelectorAll('.footer__socials a').forEach((icon) => {
    icon.addEventListener('click', () => {
      trackEvent('click_social', 'Social Links', icon.title);
    });
  });
});
